import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../api';
import TopNav from '../components/TopNav';
import BottomNav from '../components/BottomNav';

const Category = ({ deviceId }) => {
  const { category } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadProducts();
  }, [category]);

  const loadProducts = async () => {
    try {
      setLoading(true);
      const data = await api.getProducts(category);
      setProducts(data);
    } catch (error) {
      console.error('Error loading products:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: '#FEFEE3', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <TopNav deviceId={deviceId} />
        <p style={{ color: '#4C956C' }}>LOADING...</p>
        <BottomNav currentPath="/" />
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#FEFEE3', paddingBottom: '100px' }}>
      <TopNav deviceId={deviceId} currentPath="/" />
      
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
        <Link to="/" style={{ color: '#2C6E49', textDecoration: 'none', fontSize: '12px', marginBottom: '20px', display: 'inline-block' }}>
          {'<<< BACK TO SHOP'}
        </Link>
        
        <h1 style={{ fontSize: '24px', color: '#2C6E49', marginBottom: '10px', textAlign: 'center' }}>[ {category.toUpperCase()} ]</h1>
        <p style={{ fontSize: '12px', color: '#4C956C', marginBottom: '30px', textAlign: 'center' }}>{products.length} ITEMS</p>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px' }}>
          {products.map((product) => {
            // Flip support: find ANY color that has BOTH a FRONT and a BACK tag.
            // Prefer the first variant's color when it qualifies so the shown
            // image matches the default selection on the product detail page.
            const tags = product.image_tags || [];
            const firstColor = product.variants && product.variants[0] ? product.variants[0].color : null;
            const anglesByColor = tags.reduce((acc, t) => {
              if (!t || !t.color) return acc;
              acc[t.color] = acc[t.color] || {};
              if (t.angle === 'front') acc[t.color].front = t.url;
              else if (t.angle === 'back') acc[t.color].back = t.url;
              return acc;
            }, {});
            const flipColor =
              (firstColor && anglesByColor[firstColor] && anglesByColor[firstColor].front && anglesByColor[firstColor].back)
                ? firstColor
                : Object.keys(anglesByColor).find(c => anglesByColor[c].front && anglesByColor[c].back) || null;

            const frontForFirst = firstColor && anglesByColor[firstColor] && anglesByColor[firstColor].front;
            const frontForFlip = flipColor ? anglesByColor[flipColor].front : null;
            const displayImage = frontForFlip
              || frontForFirst
              || (product.variants && product.variants[0] && product.variants[0].image_url)
              || (product.images && product.images[0])
              || null;
            const backImage = flipColor ? anglesByColor[flipColor].back : null;
            const hasFlip = !!(displayImage && backImage && flipColor);

            return (
              <Link
                key={product._id}
                to={`/product/${product._id}`}
                className="retro-card"
                style={{ textDecoration: 'none', background: '#FFF', padding: '15px' }}
              >
                <div
                  className={hasFlip ? 'product-card-flip' : ''}
                  style={{
                    background: '#F7F6D8',
                    border: '2px solid #000',
                    aspectRatio: '1',
                    marginBottom: '15px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    position: 'relative',
                  }}
                >
                  {displayImage ? (
                    <>
                      <img
                        src={displayImage}
                        alt={`${product.name}${firstColor ? ` - ${firstColor}` : ''}`}
                        className={hasFlip ? 'product-card-front' : ''}
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      />
                      {hasFlip && (
                        <img
                          src={backImage}
                          alt={`${product.name}${firstColor ? ` - ${firstColor}` : ''} back`}
                          className="product-card-back"
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            pointerEvents: 'none',
                          }}
                        />
                      )}
                    </>
                  ) : (
                    <span style={{ fontSize: '48px' }}>👕</span>
                  )}
                </div>
                <h3 style={{ fontSize: '12px', color: '#2C6E49', marginBottom: '5px', fontWeight: 'bold' }}>{product.name}</h3>
                <p style={{ fontSize: '14px', color: '#2C2C2C', fontWeight: 'bold' }}>${product.base_price.toFixed(2)}</p>
              </Link>
            );
          })}
        </div>
      </div>
      
      <BottomNav currentPath="/" />
    </div>
  );
};

export default Category;
